module.exports = __webpack_public_path__ + "static/media/selfie_fondo_claro.a6d5fa36.svg";